<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img
            src="../../../assets/images/logo/logo.svg"
            class="logo-size"
          >
        </b-link>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >
            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Email"
                  class="input-color"
                  autofocus
                  @focus="error.show = false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Senha</label>
                <b-link :to="{ name: 'EsqueciSenha' }">
                  <small>Esqueceu sua senha? </small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Senha"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge input-color"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="············"
                    @focus="error.show = false"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>

                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- submit button -->
            <div
              v-if="error.show"
              class="text-danger text-center mb-1 mt-1"
            >
              {{ error.text }}
            </div>
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="signIn"
            >
              Entrar
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2 text-blue">
          <b-link :to="{ name: 'PrimeiroAcesso' }">
            <span>Primeiro acesso</span>
          </b-link>
        </b-card-text>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import {
  required,
  email,
} from '@validations'
import {
  togglePasswordVisibility,
} from '@core/mixins/ui/forms'
import { login } from '@/service/user/user'

import { callLoading, removeDarkMode } from '@/service/utilities/utilities'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      status: '',
      required,
      email,
      colorx: '#F37021',
      isLogged: false,
      errorIsTrue: false,
      error: {
        show: false,
        text: null,
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    removeDarkMode()
    const token = sessionStorage.getItem('token')
      if (token) {
        const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/selecionar'
        sessionStorage.removeItem('redirectAfterLogin')
        this.$router.push(redirectPath)
      }
  },
  methods: {
  async signIn() {
    callLoading(true)
    let isNavigating = false

    try {
    const { status, data } = await login(this.userEmail, this.password);

      if (status === 200) {
        sessionStorage.setItem('userEmail', data.email)
        sessionStorage.setItem('userTaxId', data.tax_id)

        const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/selecionar';

        isNavigating = true
        try {
          await this.$router.replace(redirectPath)
        } catch (navErr) {
          window.location.href = redirectPath;
        }
        return;
      }

      if (status === 401) {
          this.error = {
            text: 'Sua senha está incorreta. Confira-a.',
            show: true,
          }
        } else if (status === 422) {
          this.error = {
            text: 'O email inserido não pertence a uma conta. Verifique seu email e tente novamente.',
            show: true,
          }
        } else if (status === 423) {
          this.$router.push({
            path: `/redefinir-senha/${data.hash}`,
            query: {
              new_password: true,
            },
          })
        } else {
          this.error.show = false
        }
    } catch (err) {
      console.error('Erro ao logar:', err)
      this.error = { text: 'Ocorreu um erro. Tente novamente.', show: true }
    } finally {
      if (!isNavigating) {
        callLoading(false)
      }
      }
    }
  },
}
</script>

<style scoped lang="scss">
  @import "@core/scss/vue/pages/page-auth.scss";
</style>
